import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { ProjectInvoiceControl } from '../types';

import { SuccessData } from 'types/api';

type ChangePaymentMethodParams = {
  method: ProjectInvoiceControl['type'];
  justification: string;
  project: string;
  config: {
    comment: string;
    installments?: number;
  };
};

export const invoiceProjectsMutations = getMutations({
  changeProjectPaymentMethod: {
    action: async (payload: ChangePaymentMethodParams): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/payment-method',

        method: 'put',

        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('payment-method-selected'),
        type: 'success',
      }),
    },
  },

  assignInvoiceControl: {
    action: async (payload: { projectId: string; owner: string }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/assign',

        payload,
      });
    },

    messages: {
      success: (t) => t('project-assigned-with-success')!,

      error: (t) => t('error-while-assigning-project')!,
    },
  },

  sendProjectToInvoice: {
    action: async (payload: { project: string; comment: string }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/ready-to-invoice',

        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('project-marked-as-ready-to-invoice'),
        type: 'success',
      }),
    },
  },

  selectProjectPaymentMethod: {
    action: async (payload: {
      project: string;
      method: 'PACKAGE' | 'STANDARD';
      config: {
        comment: string;
        installments?: number;
      };
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/payment-method',

        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('payment-method-selected'),
        type: 'success',
      }),
    },
  },

  updateProjectFreshDeskTickets: {
    action: async (payload: { project: string; tickets: string[] }): Promise<string[]> => {
      return executeApiCall({
        path: '/invoice/projects/freshdesk-tickets',

        payload,
      });
    },
  },

  markProjectAsPaid: {
    action: async (payload: { project: string }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/mark-as-paid',

        payload,
      });
    },
  },

  changeInvoiceProjectOwner: {
    action: async (payload: {
      project: string;
      justification: string;
      owner: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/owner',

        method: 'put',

        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('project-ownership-changed'),
        type: 'success',
      }),

      error: (t) => ({
        title: t('project-ownership-error'),
        type: 'error',
      }),
    },
  },

  requestInvoiceControlCancelation: {
    action: async (payload: { projectId: string; justification: string }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/cancel/request',

        payload,
      });
    },
  },

  answerInvoiceControlCancelation: {
    action: async (payload: {
      projectId: string;
      comment: string;
      requestId: string;
      approved: boolean;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/projects/cancel/answer',

        payload,
      });
    },
  },
});
